import { atom, useAtom } from 'jotai'
import { isEqual } from 'lodash'
import { useEffect } from 'react'

type BreadCrumbLink = {
    to: string
    text: string
    params?: any
}

type BreadCrumbSeperator = 'seperator'

type BreadCrumb = BreadCrumbLink | BreadCrumbSeperator

export const breadcrumbAtom = atom<BreadCrumb[]>([])

export const useBreadcrumbs = () => {
    const [breadcrumbs] = useAtom(breadcrumbAtom)

    return breadcrumbs
}

export const useSetBreadcrumbs = (breadcrumbs: BreadCrumb[] | undefined) => {
    const [prev, setBreadcrumbs] = useAtom(breadcrumbAtom)

    breadcrumbs = isEqual(prev, breadcrumbs) ? prev : breadcrumbs

    useEffect(() => {
        setBreadcrumbs(breadcrumbs || [])

        return () => {
            setBreadcrumbs([])
        }
    }, [setBreadcrumbs, breadcrumbs])
}
